<div *adaptLoadingUntilFirstEmit="let values of values$">
    @if (values.length > 0) {
        <ul>
            @for (value of values; track value) {
                <li>
                    <a [routerLink]="value.url"
                       [queryParams]="value.queryParams">{{ value.name }}</a>
                </li>
            }
        </ul>
    } @else {
        @if (showCTA) {
            <adapt-call-to-action-inline [featureUrl]="vcUrl$ | async">
                Adapt's values tool provides a place to capture and maintain your
                {{ (team$ | async) ? "team's" : "organisation's" }} values.
            </adapt-call-to-action-inline>
        }
        @if (!showCTA) {
            <span>No values have been defined.</span>
        }
    }
</div>
